export const checkRefereeStatus = (proposalReferee) => {
  const submitStatus = {
    detaliedEvaluation: checkDetaliedEvaluation(proposalReferee),
    grading: checkGrading(proposalReferee),
    finalRecommendation: checkFinalRecommendation(proposalReferee),
  };

  return submitStatus;
};

export const checkDetaliedEvaluation = (proposalReferee) => {
  if (
    proposalReferee.detailedEvaluation === null ||
    proposalReferee.detailedEvaluation === undefined ||
    proposalReferee.detailedEvaluation === ""
  )
    return false;

  return true;
};

export const checkGrading = (proposalReferee) => {
  if (
    proposalReferee.modeOfCooperationBetweenTheTeams === null ||
    proposalReferee.modeOfCooperationBetweenTheTeams === undefined ||
    proposalReferee.modeOfCooperationBetweenTheTeams === "" ||
    proposalReferee.modeOfCooperationBetweenTheTeams === 0
  )
    return false;
  if (
    proposalReferee.originalityInnovation === null ||
    proposalReferee.originalityInnovation === undefined ||
    proposalReferee.originalityInnovation === "" ||
    proposalReferee.originalityInnovation === 0
  )
    return false;
  if (
    proposalReferee.suitabilityOfInvestigatorsScientific === null ||
    proposalReferee.suitabilityOfInvestigatorsScientific === undefined ||
    proposalReferee.suitabilityOfInvestigatorsScientific === "" ||
    proposalReferee.suitabilityOfInvestigatorsScientific === 0
  )
    return false;
  if (
    proposalReferee.adequacyOfMethods === null ||
    proposalReferee.adequacyOfMethods === undefined ||
    proposalReferee.adequacyOfMethods === "" ||
    proposalReferee.adequacyOfMethods === 0
  )
    return false;

  return true;
};

export const checkFinalRecommendation = (proposalReferee) => {
  if (
    proposalReferee.refereeFinalRecommend === null ||
    proposalReferee.refereeFinalRecommend === undefined ||
    proposalReferee.refereeFinalRecommend === "" ||
    proposalReferee.refereeFinalRecommend === 0
  )
    return false;
  if (
    proposalReferee.noteForAdvisors === null ||
    proposalReferee.noteForAdvisors === undefined ||
    proposalReferee.noteForAdvisors === ""
  )
    return false;

  return true;
};
